export default __webpack_public_path__ + "media/zurb/img/legacy/icons/notable/pro-notable-eb07a7abf33d6c0daa5786fcfc30dac2.png";